var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-btn',_vm._g(_vm._b({},'b-btn',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('font-awesome-icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"fixed-width":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }